import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingStop, login } from 'redux/action';
import { toast } from 'react-toastify';
import { DashboardContainer, Table } from 'components';
import Body from './Body';
import API from 'services/api';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';

const Index = () => {
  const dispatch = useDispatch();

  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (searchInput == '') {
      setTableData(originalData);
    } else {
      const filteredResults = originalData.filter((data) =>
        Object.values(data).join(', ').toLowerCase().includes(searchInput.toLowerCase())
      );
      setTableData(filteredResults);
    }
  }, [searchInput]);

  const init = () => {
    dispatch(loadingStart());
    API.getVegasConferenceIncompletePaymentsReport()
      .then((response) => {
        if (response) {
          setTableData(response);
          setOriginalData(response);
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  const sendIndividualMail = (paymentIntentId) => {
    const emailData = tableData.find((data) => data.paymentIntentId === paymentIntentId);
    if (!emailData) {
      toast.error('No data found for the selected payment intent ID');
      return;
    }

    dispatch(loadingStart());
    API.sendVegasConferenceIncompletePaymentsMail([emailData])
      .then((response) => {
        if (response) {
          toast.success('Email sent successfully');
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  const sendMailToAll = () => {
    dispatch(loadingStart());
    API.sendVegasConferenceIncompletePaymentsMail(tableData)
      .then((response) => {
        if (response) {
          toast.success('Emails sent successfully to all recipients');
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  return (
    <DashboardContainer>
      <Body
        _this={{
          init,
          setTableData,
          tableData,
          searchInput,
          setSearchInput,
          sendIndividualMail,
          sendMailToAll
        }}
      />
    </DashboardContainer>
  );
};

export default Index;

const HelloWorld = () => {
  return <div>Hello World</div>;
};

const ChildComponent = ({ tableData = [] }) => {
  const columns = [
    {
      accessor: 'location_name',
      Header: 'Location Name',
      headerStyle: { fontSize: '90%' },
      Cell: (row) => <div>{row.original.location_name}</div>
      // width: 200
    },
    {
      accessor: 'startSyclePatients',
      headerStyle: { fontSize: '90%' },
      Header: 'Start Sycle Patients',
      Cell: (row) => <div>{row.original.startSyclePatients}</div>
    },
    {
      accessor: 'currentSyclePatients',
      headerStyle: { fontSize: '90%' },
      Header: 'Current Sycle Patinets',
      Cell: (row) => <div>{row.original.currentSyclePatients}</div>
    },
    {
      accessor: 'startActivePatients',
      headerStyle: { fontSize: '90%' },
      Header: 'Start Active Patients',
      Cell: (row) => <div>{row.original.startActivePatients}</div>
    },
    {
      accessor: 'currentActivePatients',
      headerStyle: { fontSize: '90%' },
      Header: 'Current Active Patients',
      Cell: (row) => <div>{row.original.currentActivePatients}</div>
    },
    {
      accessor: 'percHspp',
      headerStyle: { fontSize: '90%' },
      Header: '% HSPP',
      Cell: (row) => <div>{row.original.percHspp}</div>
    },
    {
      accessor: 'startActiveSubscriptions',
      headerStyle: { fontSize: '90%' },
      Header: 'Start Active Subscriptions',
      Cell: (row) => <div>{row.original.startActiveSubscriptions}</div>
    },
    {
      accessor: 'currentActiveSubscriptions',
      headerStyle: { fontSize: '90%' },
      Header: 'Current Active Subscriptions',
      Cell: (row) => <div>{row.original.currentActiveSubscriptions}</div>
    },
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Patient Added',
      accessor: 'patientAdded',
      Cell: (row) => <div>{row.original.patientAdded}</div>
    },
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Subscription Added',
      accessor: 'subscriptionAdded',
      Cell: (row) => <div>{row.original.subscriptionAdded}</div>
    }
  ];
  return (
    <Table
      keyField="_id"
      columns={columns}
      data={tableData}
      headerComponent={null}
      maxRows={20}
      minRows={1}
    />
  );
};
